import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Checkbox, FormControlLabel, FormGroup, Grid, Typography } from '@mui/material';
import { useContext } from 'react';
import { NewBookingContext } from '../NewBookingContext';
import { DurationDay } from './DurationDay';
export const AddAbsencePeriodPage = ({ duration }) => {
    const { startInAfternoon, endInMorning, updateState } = useContext(NewBookingContext);
    const onStartInAfternoon = (_, checked) => {
        updateState((state) => ({ ...state, startInAfternoon: checked }));
    };
    const onEndInMorning = (_, checked) => {
        updateState((state) => ({ ...state, endInMorning: checked }));
    };
    return (_jsxs(Grid, { container: true, p: 2, spacing: 1, children: [_jsx(Grid, { item: true, xs: 12, display: 'flex', gap: 1, pb: 2, children: _jsx(DurationDay, { duration: duration }) }), _jsx(Grid, { item: true, xs: 12, children: _jsxs(FormGroup, { children: [_jsx(FormControlLabel, { checked: startInAfternoon, onChange: onStartInAfternoon, control: _jsx(Checkbox, {}), label: _jsx(Typography, { variant: 'subtitle1', children: "Start in afternoon" }) }), _jsx(FormControlLabel, { checked: endInMorning, onChange: onEndInMorning, control: _jsx(Checkbox, {}), label: _jsx(Typography, { variant: 'subtitle1', children: "End in morning" }) })] }) })] }));
};
